import { getLocalStorage, setLocalStorage } from '@repo/utils/client'

export enum ConsentType {
  Earn = 'earn',
  Borrow = 'borrow'
}

/**
 * Generates localStorage key for consent type.
 * @param type - Consent type (Earn or Borrow)
 * @returns localStorage key string
 */
export const consentLocalStorageKey = (type: ConsentType) => `morpho.consent.${type}`

/**
 * Internal helper to set consent status in localStorage.
 * @param type - Consent type
 * @param status - Consent status (true/false)
 */
const _setConsent = (type: ConsentType, status: boolean) => {
  const key = consentLocalStorageKey(type)
  setLocalStorage(key, status)
}

/**
 * Checks if user has given consent for a specific type.
 * @param type - Consent type to check
 * @returns True if consent given, false otherwise
 */
export const getConsent = (type: ConsentType) => {
  const key = consentLocalStorageKey(type)
  return getLocalStorage(key) === true
}

/**
 * Records user consent for a specific type.
 * @param type - Consent type to grant
 */
export const giveConsent = (type: ConsentType) => {
  _setConsent(type, true)
}

/**
 * Removes user consent for a specific type.
 * @param type - Consent type to remove
 * @internal
 */
export const removeConsent = (type: ConsentType) => {
  _setConsent(type, false)
}
